<template>
  <div class="visual-id-links">
    <a @click="goToPage('logotype')">Logo</a>
    <a @click="goToPage('pixel-head')">Pixel Head</a>
    <a @click="goToPage('typography')">Fonts</a>
    <a @click="goToPage('colors')">Colors</a>
    <a @click="goToPage('templates')">Templates</a>
    <a @click="goToPage('images')">Images</a>
    <a @click="goToPage('videos')">Videos</a>
    <a @click="goToPage('icons')">Icons</a>
  </div>
</template>

<script>

export default {
  name: 'ViLinks',
  props: [],
  methods: {
    goToPage(pageLink) {
      this.$router.push(pageLink);
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .visual-id-links
    display: flex
    flex-flow: wrap
    justify-content: center
    gap: 0.8rem
    max-width: 90rem
    margin: 6rem auto 5rem auto
    padding: 0 2rem

    a
      padding: 1rem 2rem
      background-color: $secondary-color
      border-radius: 0.2rem
      cursor: pointer

      &:hover
        background-color: #FFD4C0
        transition: 0.2s

</style>
